import React from "react";
import { Box, Typography, dialogTitleClasses } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useDropzone } from "react-dropzone";
import I18n from "i18next";

import MzButton from "@markaaz/ui/MzButton";
import { MzDialog, MzDialogTitle, MzDialogContent, MzDialogActions } from "@markaaz/ui/MzDialogControls";

const sx = {
  content: {
    backgroundColor: "blue.c5",
    padding: "50px 0",
    gap: "30px",
    minHeight: "200px",

    [`.${dialogTitleClasses.root} + &`]: {
      paddingTop: "50px"
    }
  },
  xlsx: {
    fontSize: "12px",
    color: "#66668F"
  },
  tile: {
    wordBreak: "break-all",
    padding: "40px",
    textAlign: "center"
  },

  circle: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "common.white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "blue.c100"
  }
};

const FileUpload = ({ isOpen, showSpinner, onUpload, onClose }) => {
  const [file, setFile] = React.useState(false);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => setFile(files[0]),
    accept: {
      "text/csv": [".csv"]
    }
  });

  function handleClose() {
    setFile(false);
    onClose();
  }

  function handleSubmit(e) {
    e.preventDefault();
    onUpload(file);
    setFile(false);
  }

  return (
    <MzDialog open={isOpen} onClose={handleClose}>
      <MzDialogTitle>{I18n.t("common.uploadNewFile")}</MzDialogTitle>
      <MzDialogContent sx={sx.content} {...getRootProps()}>
        <input {...getInputProps()} />

        <Box sx={file && sx.tile}>
          {isDragActive ? (
            <Typography variant="body2M">{I18n.t("common.dropFileHere")}</Typography>
          ) : file ? (
            <Typography variant="body2B">{file.name}</Typography>
          ) : (
            <Typography variant="body2">
              {" "}
              <MzButton>{I18n.t("common.browseaFile")}</MzButton> {I18n.t("common.dragAndDrop")}{" "}
            </Typography>
          )}
        </Box>

        {!file && (
          <Box sx={sx.circle}>
            {" "}
            <FileUploadOutlinedIcon />
          </Box>
        )}

        <Typography variant="caption">{I18n.t("common.csvSupported")}</Typography>
      </MzDialogContent>
      <MzDialogActions>
        <MzButton onClick={handleClose} variant="outlined" color="secondary" size="large">
          {I18n.t("common.cancel")}
        </MzButton>
        <MzButton onClick={handleSubmit} variant="contained" color="primary" size="large" disabled={showSpinner}>
          {I18n.t("common.submit")}
        </MzButton>
      </MzDialogActions>
    </MzDialog>
  );
};

export default FileUpload;
